import type {
  Hero as IHeroProps,
  StoreHero as IStoreHero,
  VapsHero as VapsHeroProps,
} from '@cinch-nx/data-storyblok'
import {
  GenericHero,
  HeroWithRichText,
  type IHeroWithRichTextProps,
  LandingHero,
  StoreHero,
  HeroSection,
  type HeroSectionProps,
  VapsHero,
} from './variants'
import { LandingHeroProps } from './variants/landing-hero/landing-hero'

export interface IHeroComponentProps {
  heroProps:
    | IHeroProps
    | IHeroWithRichTextProps
    | IStoreHero
    | LandingHeroProps
    | undefined
}

export const Hero = ({ heroProps }: IHeroComponentProps) => {
  switch (heroProps?.component) {
    case 'GenericHero': {
      return <GenericHero {...(heroProps as IHeroProps)} />
    }
    case 'CarFinanceHero': {
      return <HeroWithRichText {...(heroProps as IHeroWithRichTextProps)} />
    }
    case 'StoreHero': {
      return <StoreHero {...(heroProps as IStoreHero)} />
    }
    case 'LandingHero': {
      return <LandingHero {...(heroProps as LandingHeroProps)} />
    }
    case 'HeroSection': {
      return <HeroSection {...(heroProps as HeroSectionProps)} />
    }
    case 'VapsHero': {
      return <VapsHero {...(heroProps as VapsHeroProps)} />
    }
    default: {
      return null
    }
  }
}
